// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

/* Make video fill the container */
.zego-video-container video {
    object-fit: cover;
    width: 100% !important;
    height: 100% !important;
}
.zego_model_parent{
  min-width: unset !important;
  height: unset !important;
  min-height: unset !important;
  background: transparent !important;
  min-height: 225px !important;

 
}
.zego_model_parent #ZegoRoomFooter {
  display: none !important;

}
.zego_model_parent>:first-child {
  display: none !important;

}
.zego_model_parent > :nth-child(2) {
  width: 100%  !important;
  margin: 0 !important;
}
.zego_model_parent > :nth-child(2) > :nth-child(1) {
     border-radius: 20px !important;
     border: 3px solid #e7b308 !important;
     text-align: center !important;
}
 .ZegoRoomMobile_ZegoRoom {
  background: transparent !important;
}
.zg_autoplay_mask{
  display: none !important;
}
#zego_left_notify_wrapper + div{
  display: none !important;
}

  
  .latestDrawnBall {
    position: absolute;
    top: 10px;
    right: 10px;
    height: 4rem;
    width: 4rem;
    background-color: white;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size:2rem;
    font-weight: 700;
    animation: fadeInOut 4s ease-in-out forwards;
    z-index: 501;
  }
  
  @keyframes fadeInOut {
    0% {
      opacity: 1;
    }
  
    50% {
      opacity: 1;
    }
  
    100% {
      opacity: 0;
    }
  }
  
  .mainNumber {
    background: linear-gradient(135deg, #dbbbff, #9f58f2, #7725d6);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    color: #ffffff;
  }
  
  .bonusNumber {
    background: linear-gradient(135deg, #ffb18d, #fe9260, #e95f1e);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    color: #5f3372;
  }
  
  
  /* Blinking animation */
  @keyframes blink {
  
    0%,
    100% {
      opacity: 1;
    }
  
    50% {
      opacity: 0;
    }
  }

  @media screen and (max-width:768px) {
  
    .zegoUserVideo_click{
      font-size: 12px !important;
      line-height: 1.3 !important;
      text-align: center !important;
    }
    .latestDrawnBall {
      position: absolute;
      top: 4px;
      right: 6px;
      height: 3rem;
      width: 3rem;
      font-size: 1.5rem;
     
    }
  
  }
  @media screen and (min-width:768px) and (max-width:1280px) {
  
    .unmuteVideo{
      font-size: 12px !important;
    }
    .unmuteVideo + span{
      width: 19px !important;
      height: 19px !important;
    }
  
  }
  @media screen and (min-width:1024px) and (max-width:1440px) {
  
    .zego_model_parent{
      min-height: 140px !important;
    
     
    }
  
  }`, "",{"version":3,"sources":["webpack://./src/components/ZegoCloudStream/ZegoCloudStream.css"],"names":[],"mappings":";;AAEA,kCAAkC;AAClC;IACI,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;EAC5B,kCAAkC;EAClC,4BAA4B;;;AAG9B;AACA;EACE,wBAAwB;;AAE1B;AACA;EACE,wBAAwB;;AAE1B;AACA;EACE,uBAAuB;EACvB,oBAAoB;AACtB;AACA;KACK,8BAA8B;KAC9B,oCAAoC;KACpC,6BAA6B;AAClC;CACC;EACC,kCAAkC;AACpC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;;;EAGE;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,4CAA4C;IAC5C,YAAY;EACd;;EAEA;IACE;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;IACZ;EACF;;EAEA;IACE,8DAA8D;IAC9D,wCAAwC;IACxC,cAAc;EAChB;;EAEA;IACE,8DAA8D;IAC9D,wCAAwC;IACxC,cAAc;EAChB;;;EAGA,uBAAuB;EACvB;;IAEE;;MAEE,UAAU;IACZ;;IAEA;MACE,UAAU;IACZ;EACF;;EAEA;;IAEE;MACE,0BAA0B;MAC1B,2BAA2B;MAC3B,6BAA6B;IAC/B;IACA;MACE,kBAAkB;MAClB,QAAQ;MACR,UAAU;MACV,YAAY;MACZ,WAAW;MACX,iBAAiB;;IAEnB;;EAEF;EACA;;IAEE;MACE,0BAA0B;IAC5B;IACA;MACE,sBAAsB;MACtB,uBAAuB;IACzB;;EAEF;EACA;;IAEE;MACE,4BAA4B;;;IAG9B;;EAEF","sourcesContent":["\n\n/* Make video fill the container */\n.zego-video-container video {\n    object-fit: cover;\n    width: 100% !important;\n    height: 100% !important;\n}\n.zego_model_parent{\n  min-width: unset !important;\n  height: unset !important;\n  min-height: unset !important;\n  background: transparent !important;\n  min-height: 225px !important;\n\n \n}\n.zego_model_parent #ZegoRoomFooter {\n  display: none !important;\n\n}\n.zego_model_parent>:first-child {\n  display: none !important;\n\n}\n.zego_model_parent > :nth-child(2) {\n  width: 100%  !important;\n  margin: 0 !important;\n}\n.zego_model_parent > :nth-child(2) > :nth-child(1) {\n     border-radius: 20px !important;\n     border: 3px solid #e7b308 !important;\n     text-align: center !important;\n}\n .ZegoRoomMobile_ZegoRoom {\n  background: transparent !important;\n}\n.zg_autoplay_mask{\n  display: none !important;\n}\n#zego_left_notify_wrapper + div{\n  display: none !important;\n}\n\n  \n  .latestDrawnBall {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    height: 4rem;\n    width: 4rem;\n    background-color: white;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size:2rem;\n    font-weight: 700;\n    animation: fadeInOut 4s ease-in-out forwards;\n    z-index: 501;\n  }\n  \n  @keyframes fadeInOut {\n    0% {\n      opacity: 1;\n    }\n  \n    50% {\n      opacity: 1;\n    }\n  \n    100% {\n      opacity: 0;\n    }\n  }\n  \n  .mainNumber {\n    background: linear-gradient(135deg, #dbbbff, #9f58f2, #7725d6);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    color: #ffffff;\n  }\n  \n  .bonusNumber {\n    background: linear-gradient(135deg, #ffb18d, #fe9260, #e95f1e);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    color: #5f3372;\n  }\n  \n  \n  /* Blinking animation */\n  @keyframes blink {\n  \n    0%,\n    100% {\n      opacity: 1;\n    }\n  \n    50% {\n      opacity: 0;\n    }\n  }\n\n  @media screen and (max-width:768px) {\n  \n    .zegoUserVideo_click{\n      font-size: 12px !important;\n      line-height: 1.3 !important;\n      text-align: center !important;\n    }\n    .latestDrawnBall {\n      position: absolute;\n      top: 4px;\n      right: 6px;\n      height: 3rem;\n      width: 3rem;\n      font-size: 1.5rem;\n     \n    }\n  \n  }\n  @media screen and (min-width:768px) and (max-width:1280px) {\n  \n    .unmuteVideo{\n      font-size: 12px !important;\n    }\n    .unmuteVideo + span{\n      width: 19px !important;\n      height: 19px !important;\n    }\n  \n  }\n  @media screen and (min-width:1024px) and (max-width:1440px) {\n  \n    .zego_model_parent{\n      min-height: 140px !important;\n    \n     \n    }\n  \n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
